import { Component, OnInit, Input, OnChanges, Output, EventEmitter, ViewChild, AfterViewInit, AfterContentInit, AfterContentChecked, ElementRef, AfterViewChecked, OnDestroy } from '@angular/core';
import { ShiftInfo, ShiftTaskInfo } from '../types';
import { InfoActionService } from '../../../../element-utils/element-actions/info-action/info-action.service';
import { VRGroupService } from '../../vrgroup.service';
import { AppMessageService } from '../../../../shared/app-message/app-message.service';
import { AppMessage } from '../../../../shared/app-message/app-message';
import { _ } from '~shared/utils';

@Component({
  selector: 'qm-vr-workshift-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss']
})
export class TooltipComponent implements OnInit, OnChanges, AfterViewChecked, OnDestroy {
  @Input()
  shiftInfo: ShiftInfo;
  @Input()
  shiftTaskInfo: ShiftTaskInfo[];
  @Output()
  loaded = new EventEmitter<DOMRect>();
  @ViewChild('tooltipelem') private tooltip: ElementRef<HTMLDivElement>;

  constructor(
    private vrGroupService: VRGroupService,
    private infoActionService: InfoActionService,
    private appMessageService: AppMessageService) { }

  ngOnInit() {
  }
  ngOnChanges() {
    if (this.tooltip) {
      this.loaded.next(this.tooltip.nativeElement.getBoundingClientRect());
    }
  }
  ngAfterViewChecked() {
    if (this.tooltip) {
      this.loaded.next(this.tooltip.nativeElement.getBoundingClientRect());
    }
  }
  ngOnDestroy() {
    this.tooltip = null;
  }

  async openTrainInfo(event: Event, taskInfo: ShiftTaskInfo): Promise<void> {
    event.preventDefault();

    let feature;
    try {
      feature = await this.vrGroupService.getTrainMapElement(taskInfo.taskLabel, taskInfo.operatingDate);
    } catch (err) {
      console.error('getTrainMapElement failed: ', err);
    }

    if (feature) {
      this.infoActionService.openDetails(feature.layer, feature, 'personel');
    } else {
      console.warn('No data found for selected train');
      const msgText = _('Train information is not available');
      this.appMessageService.broadcastAlarm(new AppMessage(true, msgText, 'warning', ''));
    }
  }

}
